import { render, staticRenderFns } from "./inventoryDetailReport.vue?vue&type=template&id=32386cb2"
import script from "./inventoryDetailReport.vue?vue&type=script&lang=js"
export * from "./inventoryDetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports